import styled from 'styled-components';

export const FormWrapper = styled.div`
  width: 100%;
  display: flex;
  column-gap: 40px;
  .ant-form-item {
    min-width: 288px;
  }
`;

export const EmailTemplateFormWrapper = styled.div`
  display: flex;
  gap: 24px;
  width: 100%;
  .email-template-form {
    width: 100%;
    max-width: 900px;
  }
`;

export const DeleteContainer = styled.div<{ isIcon: boolean }>`
  display: flex;

  ${({ isIcon }) =>
  isIcon &&
  `
    & > div:last-child {
        cursor: pointer;
        margin-left: 18px;
        margin-top: 7px;
    }
  `}
`;

export const FormListWrapper = styled.div<{ isIcon: boolean; }>`
  display: flex;
  flex-direction: column;

  & > div:last-child {
    margin-top: 10px;
    margin-right: ${({ isIcon }) => (isIcon ? '40px' : 0)};
    align-self: flex-end;

    .ant-btn {
      padding: 0;
    }
  }
`;
